<template>
    <div class="py-4 lg:px-1">
        <a :href="link">
            <div :class="alertColour" class="p-2 items-center text-indigo-100 leading-none md:rounded-full rounded flex lg:inline-flex" role="alert">
                <span :class="badgeColour" class="flex rounded-full uppercase px-2 py-1 text-xs font-bold mr-3">{{ alertText }}</span>
                <span class="font-semibold mr-2 text-left flex-auto">{{ badgeText }}</span>
                <svg v-if="link" class="fill-current opacity-75 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z"/></svg>
            </div>
        </a>
    </div>
</template>

<script>
    export default {
        name: "ModernAlert",
        props: [
            'badgeColour',
            'badgeText',
            'alertColour',
            'alertText',
            'link'
        ],
    }
</script>